import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:_vm.customClass},_vm.$listeners),[(_vm.loading)?_c(VProgressCircular,{attrs:{"indeterminate":""}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }